module.exports = __webpack_public_path__ + "static/media/logotypywszystkie.76de3ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logotypywszystkie.png
// module id = 391
// module chunks = 0